var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoRedPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29338 17.0045C7.17546 19.1363 3.57639 19.8422 1.5 17.7105C4.26852 14.8451 1.5 13.4608 3.57639 11.3844C3.94098 10.9783 4.38456 10.6508 4.88002 10.4219C5.37548 10.193 5.91241 10.0675 6.458 10.0531C7.00359 10.0388 7.54638 10.1358 8.05319 10.3384C8.56001 10.5409 9.0202 10.8446 9.40565 11.231C9.7911 11.6174 10.0937 12.0783 10.295 12.5856C10.4963 13.0929 10.592 13.636 10.5763 14.1815C10.5606 14.7271 10.4338 15.2637 10.2037 15.7586C9.97363 16.2535 9.64503 16.6963 9.23801 17.0599L9.29338 17.0045Z",
    fill: "#FF0000",
    stroke: "#0C002C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.696 1.80507C18.4275 1.53832 18.1072 1.32945 17.7548 1.19136C17.4024 1.05327 17.0255 0.988889 16.6473 1.0022C16.2693 1.01248 15.8974 1.10007 15.5546 1.25958C15.2118 1.41909 14.9052 1.64713 14.6539 1.92965L7.27344 10.1071C8.07204 10.2652 8.73535 10.7947 9.29686 11.3841C9.80188 11.8871 10.2358 12.3835 10.4296 13.0694L18.5714 5.84711C18.8522 5.59738 19.0793 5.29309 19.2388 4.95277C19.3982 4.61246 19.4867 4.24324 19.4988 3.86762C19.5141 3.48709 19.4506 3.10751 19.3125 2.75262C19.1743 2.39773 18.9645 2.07516 18.696 1.80507Z",
    fill: "#FF0000",
    stroke: "#0C002C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRedPen);
export default __webpack_public_path__ + "static/media/ico_red_pen.9f27164477a3720ddd669c9a9d604c91.svg";
export { ForwardRef as ReactComponent };